/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { MarkReservationPaidPathParameters } from 'api/actions/mark-reservation-paid/mark-reservation-paid-path-parameters';
import { MarkReservationPaidResponse } from 'api/actions/mark-reservation-paid/mark-reservation-paid-response';

type MarkReservationPaidQueryParameters = Record<string, any>;

/**
 * The path of the MarkReservationPaid action.
 */
export const markReservationPaidActionPath = new SweetPath<keyof MarkReservationPaidPathParameters>(
  '/admin/custom/reservations/{reservationId}/mark-paid',
  { path: '{param}' }
);

/**
 * Creates a contextualized MarkReservationPaid actions.
 */
export default function createMarkReservationPaidAction(axios: AxiosInstance) {
  return function markReservationPaidAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: MarkReservationPaidPathParameters;
    query?: MarkReservationPaidQueryParameters;
  }) {
    const path = markReservationPaidActionPath.insert(parameters);

    return axios.post<MarkReservationPaidResponse, MarkReservationPaidResponse>(path, { params: query, headers });
  };
}
